import React, { Component } from 'react';
import { func, object, number, array, string, oneOfType, bool } from 'prop-types';
import SlideoutHeader from 'ps-components/Slideout/Header/SlideoutHeader';
import GradeListViewFooter from './subcomponents/GradeListViewFooter';
import SlideoutBody from 'ps-components/Slideout/Body/SlideoutBody';
import { SMA_BASIS_KEY } from './StructureModelingAnalyticsSlideout';
import Dropdown from 'ps-components/Dropdown/Dropdown';
import SlideoutHeaderButton from 'ps-components/Slideout/Header/SlideoutHeaderButton';
import StructureModelingAnalyticsTable from './subcomponents/StructureModelingAnalyticsTable';
import { getPdfFooter, getPdfHeader } from '../../../lib/printHelpers';

import './StructureModelingAnalyticsSlideout.scss';
import { MODEL_TYPE } from './reducers/GradeListReducer';

export default class GradeListView extends Component {
  static propTypes = {
    hideSlideout: func,
    smaData: array,
    typeOfStructure: string,
    totals: object,
    modelId: oneOfType([string, number]),
    gradeListLoading: bool,
    clickGrade: func,
    printGradeListPdf: func,
    isPdf: bool,
    csrfPair: object,
    modelName: string,
    isPrinting: bool,
    basis: string,
    setBasis: func,
    basisOptions: array,
    loadingGrade: bool,
    organizationId: string
  };

  static defaultProps = {
    modelId: '',
    isPdf: false,
    basis: 'base'
  };

  constructor(props) {
    super(props);
    this.printGradeList = this.printGradeList.bind(this);
    this.onBasisChange = this.onBasisChange.bind(this);
  }

  printGradeList() {
    const { csrfPair, modelId, modelName, printGradeListPdf, isPrinting, basis, basisOptions } = this.props;
    const bodyText = `
    <div style="float: right; text-align: right;">
        <div style="color: #2d67b9;">Current</div>
        <div style="color: #22d6dd; font-weight: 700">Proposed</div>
    </div> `;
    const foundLabel = basisOptions.find(({ value }) => value === basis)?.label;
    const appendedName =
      modelName + (foundLabel ? ' - ' + basisOptions.find(({ value }) => value === basis)?.label : '');
    if (!isPrinting)
      printGradeListPdf(modelId, basis, csrfPair, appendedName, getPdfHeader(appendedName, bodyText), getPdfFooter());
  }

  onBasisChange(option) {
    const basisValue = this.props.basisOptions.find(({ label }) => label === option).value;
    localStorage.setItem(SMA_BASIS_KEY + '_' + this.props.organizationId, basisValue);
    this.props.setBasis(basisValue);
  }

  render() {
    const {
      typeOfStructure,
      totals,
      modelId,
      gradeListLoading,
      clickGrade,
      isPdf,
      isPrinting,
      preferences,
      basis,
      basisOptions,
      loadingGrade
    } = this.props;
    const isNew = MODEL_TYPE.NEW === typeOfStructure;

    // Renders differently if you are printing as PDF
    if (isPdf) {
      const tfootData = { ...totals, grade: 'Totals' };
      return (
        <div className="structure-model-analytics">
          <SlideoutBody>
            <StructureModelingAnalyticsTable
              smaData={this.props.smaData}
              typeOfStructure={typeOfStructure}
              modelId={modelId}
              gradeListLoading={gradeListLoading}
              clickGrade={!isPdf && clickGrade}
              tfootData={tfootData}
              isPdf={isPdf}
              preferences={preferences}
              basis={basis}
              loadingGrade={loadingGrade}
            />
          </SlideoutBody>
        </div>
      );
    }
    const printButton = (
      <SlideoutHeaderButton
        buttonClass="sma-grade-list-print"
        iconClass={isPrinting ? 'icon-spin icon-animate-spin sma-disabled-icon' : 'icon-download'}
        onClick={this.printGradeList}
        tooltip={'Download to PDF'}
        testId={'sma-grade-list-print'}
      />
    );
    // Regular render (non-print)
    return (
      <React.Fragment>
        <SlideoutHeader
          title={this.props.modelName}
          doClose={this.props.hideSlideout}
          additionalButtons={printButton}
        />
        <SlideoutBody>
          <div className="sma-slideout-model-left-container">
            <span className="sma-slideout-basis-text">Calculate the cost based on </span>
            <Dropdown
              className="sma-slideout-basis-dropdown"
              dropdownClass="sma-slideout-basis-dropdown-select"
              itemOnClick={this.onBasisChange}
              rightBound={false}
              text={basisOptions.find(({ value }) => value === this.props.basis).label}
              dropdownItems={basisOptions.map(option => option.label)}
            />
          </div>
          <div className="sma-slideout-text">
            {!isNew && 'Current'}
            <div className="proposed-text-header">Proposed</div>
          </div>
          <StructureModelingAnalyticsTable
            smaData={this.props.smaData}
            typeOfStructure={typeOfStructure}
            modelId={modelId}
            gradeListLoading={gradeListLoading}
            clickGrade={!isPdf && clickGrade}
            preferences={preferences}
            basis={basis}
            loadingGrade={loadingGrade}
          />
        </SlideoutBody>
        <GradeListViewFooter totals={totals} typeOfStructure={typeOfStructure} preferences={preferences} />
      </React.Fragment>
    );
  }
}
